<div class="cs-nav-drop-down-overlay" (click)="backDropClick()" *ngIf="displayDropDown"></div>
<button class="cs-icon-btn position-relative trigger" type="button" title="notifications"
  id="notifications_btn_notification" (click)="openDropDown()">
  <span class="notification-badge" #countRef></span>
  <cs-icon icon="notification" class="notification"></cs-icon>
</button>

<div class="notification-content" *ngIf="displayDropDown" (click)="stopPropagation($event)">
  <div class="heading">
    <h5>
      Notifications
    </h5>
    <button *ngIf="notifications.length > 0" class="cs-icon-btn" (click)="clearAllNotifications()">
      Clear All
    </button>
  </div>
  <div class="notification-box">
    <a class="message" *ngFor="let item of notifications ; index as i" [routerLink]="item.action"
      [queryParams]="item.params!" (click)="notificationClick(item.notificationId)" [@notifyLeave]>
      <div class="d-flex">
        <cs-icon [icon]="item.icon!"></cs-icon>
        <div class="ml-3 d-flex flex-column w-100 mr-3">
          <div [class.notify-unread]="item.isRead === false" [class.notify-read]="item.isRead === true">
            <h6>
              {{item.notificationTitle}} </h6>
            <p *ngIf="item.associatedNumber">
              Associated to
              <a [routerLink]="item.action" [queryParams]="item.params!">
                #{{item.associatedNumber}}
              </a>
            </p>
            <p class="m-0 note-message">
              {{item.notificationMessage}}
              <span *ngIf="item.actionText==='SiteVisit' || item.actionText==='Task'">
                {{item.dueDate | fromUTC }}</span>
            </p>
          </div>
        </div>
        <button class="cs-icon-btn clear" (click)="clearNotification(i, $event)">
          <cs-icon icon="notification-close"></cs-icon>
        </button>
      </div>
    </a>
    <div class="no-notifications" *ngIf="notifications.length==0">
      <cs-icon icon="no-notifications" height="50%" width="50%" class="w-50"></cs-icon>
      <p class="text-center">No Notifications</p>
    </div>
  </div>
  <button *ngIf="notifications.length > 0" class="cs-icon-btn view-more" (click)="viewMore()" type="button"
    [class.no-more]="!showViewMore">
    {{showViewMore ? 'View More' : 'No More Notification'}}
  </button>
</div>
